import styled, { css } from 'styled-components';
import { vars } from '../../theme';
import { Z_INDEX } from '../../styles/variables';
import { applyOpacity } from '../../utils/color.utils';
import { spin } from '../../styles/animations';

export type TLoaderSize = 'xxs' | 'xs' | 'small' | 'medium' | 'large';
export const Wrapper = styled.div<{ floatCenter?: boolean }>`
    ${({ floatCenter }) =>
        floatCenter &&
        css`
            transform: translate(-50%, -50%);
            position: absolute;
            z-index: ${Z_INDEX.LOADER};
            left: 50%;
            top: 50%;
        `}
`;

function getSize(size: TLoaderSize) {
    switch (size) {
        case 'large':
            return css`
                height: 80px;
                width: 80px;
                border-width: 6px;
            `;
        case 'medium':
            return css`
                height: 40px;
                width: 40px;
                border-width: 4px;
            `;
        case 'small':
            return css`
                height: 24px;
                width: 24px;
                border-width: 2px;
            `;
        case 'xxs':
            return css`
                height: 12px;
                width: 12px;
                border-width: 2px;
            `;
        case 'xs':
        default:
            return css`
                height: 16px;
                width: 16px;
                border-width: 2px;
            `;
    }
}

export const Loader = styled.div<{
    size: TLoaderSize;
    color: string;
}>`
    padding: 0;
    border: 2px solid ${applyOpacity(vars.colors.text.primary, 40)};
    border-right: 2px solid ${({ color }) => color};
    border-bottom: 2px solid ${({ color }) => color};
    border-left: 2px solid ${({ color }) => color};
    border-radius: ${vars.radius.full};
    height: 50px;
    width: 50px;
    animation: ${spin} 0.5s infinite linear;
    ${({ size }) => getSize(size)}
`;
